import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  cidades: [],
};

const getters = {
  // Prioridade
  cidades: state => state.cidades,
}

const actions = {
  // Prioridade
  async fetchCidades({ commit }) {
    const response = await axios.get(`${baseUrl}/cidades`);
    if (response.data) {
      commit('setCidades', response.data);
    } else {
      commit('setCidades', []);
    }
  },
  async fetchCidadesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/cidades?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setCidades', response.data);
      } else {
        commit('setCidades', []);
      }
    } catch (error) {
      commit('setCidades', []);
    }
  },
}

const mutations = {
  // Cidade
  setCidades: (state, cidades) => state.cidades = cidades,
}

export default {
  state,
  getters,
  actions,
  mutations
}